import React from "react";
import loadable from "@loadable/component";
import Loading from "../Loading";

const LoadableComponent = loadable(() => import("../../students/Register"), {
  fallback: (() => <Loading />)(),
});

const Component = () => <LoadableComponent />;

export default Component;
